import { Controller } from 'stimulus';

export default class extends Controller {
  download() {
    const blob = new Blob([this.values], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');

    a.href = url;
    a.download = 'fox_insight_recovery_codes.txt';

    document.body.appendChild(a);
    a.click();

    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }

  print() {
    const printTab = window.open('about:blank', '_blank');
    printTab.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Fox Insight - Recovery Codes</title>
          <style>
            body {
              display: flex;
              flex-direction: column;
              font-family: -apple-system,BlinkMacSystemFont,"Segoe UI","Noto Sans",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji"
            }

            .title {
              font-size: 24px;
              font-weight: bold;
            }

            .container {
              border: 2px solid #e8ecee;
              padding: 24px;
              margin: 0 auto;
              margin-top: 48px;
              width: 80vw;
            }

            .code-list > * + * {
              margin-top: 12px;
            }

            .code-list > * {
              font-family: "ui-monospace", "SFMono-Regular", "SF Mono", "Menlo", "Consolas", "Liberation Mono", monospace;
            }

            .footer {
              margin-top: 24px;
            }
          </style>
        </head>
        <body>
          <div class="container">
            <p class="title">Recovery Codes</p>
            <ul class="code-list">
              ${this.values
                .split('\n')
                .map((item) => `<li>${item}</li>`)
                .join('\n')}
            </ul>
            <p class="footer">
              Fox Insight two-factor authentication recovery codes.
            </p>
          </div>
        </body>
      </html>
    `);

    // Close the document writing
    printTab.document.close();

    // Force focus to the new tab
    printTab.window.focus();

    // Use timeout to delay print dialog to allow time for the page to render
    setTimeout(() => {
      printTab.window.print();
    }, 250);

    // Close after printing (when dialog is closed)
    printTab.onafterprint = () => {
      printTab.close();
    };
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.values);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  }

  get values() {
    return this.data.get('values');
  }
}
